import api from "@/http/xior";

export type AuthUser = {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    role: "PARENT" | "ADMIN";
};

export type AuthTokenPayload = {
    token: string;
    user: AuthUser;
};

export type AuthSessionPayload = {
    user: AuthUser;
};

type ApiEnvelope<T> = {
    statusCode: number;
    message: string;
    timestamp: string;
    data: T;
};

import type { LoginRequest, RegisterRequest } from "@/types/app/auth.type";

export const authApi = {
    login: async (data: LoginRequest): Promise<AuthTokenPayload> => {
        const response = await api.post<ApiEnvelope<AuthTokenPayload>>("/auth/login", data);
        return response.data.data;
    },

    register: async (data: RegisterRequest): Promise<AuthTokenPayload> => {
        const response = await api.post<ApiEnvelope<AuthTokenPayload>>("/auth/register", data);
        return response.data.data;
    },

    session: async (): Promise<AuthSessionPayload> => {
        const response = await api.post<ApiEnvelope<AuthSessionPayload>>("/auth/sessionToken");
        return response.data.data;
    },
};